// Promotion Form New - JavaScript functionality
// This file handles the JavaScript logic for the new promotion form

(function () {
  "use strict";

  // Get locale from data attribute
  function getLocale() {
    var formElement = document.querySelector(
      "#new_promotion, .promotion-form-new",
    );
    return formElement ? formElement.getAttribute("data-locale") || "en" : "en";
  }

  // Update language selection styles
  function updateLanguageSelectionStyles() {
    $(".lang_select").each(function () {
      var $langSelect = $(this);
      var $span = $langSelect.find("span.text-sm");

      if ($langSelect.hasClass("a__lang-selected")) {
        $langSelect
          .removeClass("bg-white border")
          .addClass("bg-blue-50 border");
        $span
          .removeClass("font-medium text-gray-600")
          .addClass("font-semibold text-neutrals-90");
      } else {
        $langSelect
          .removeClass("bg-blue-50 border")
          .addClass("bg-white border");
        $span
          .removeClass("font-semibold text-neutrals-90")
          .addClass("font-medium text-gray-600");
      }
    });
  }

  // Override the default lang_select click handler to update styles
  function initializeLanguageSelection() {
    setTimeout(function () {
      $(document)
        .off("click", ".lang_select")
        .on("click", ".lang_select", function () {
          var language = $(this).attr("id").split("-").pop();
          $(".language-switch").addClass("hide");
          $(".lang_select").removeClass("a__lang-selected");
          $(".p-t__name-description--" + language).removeClass("hide");
          $(".lang_select_" + language).addClass("a__lang-selected");
          updateLanguageSelectionStyles();
        });
    }, 100);

    setTimeout(function () {
      updateLanguageSelectionStyles();
    }, 200);
  }

  // Update promotion type styles
  function updatePromoTypeStyles() {
    $('input[name="promotion[promotion_type]"]').each(function () {
      var $radio = $(this);
      var $label = $radio.closest("label");
      var $iconSpan = $label.find(".promo-icon-default, .promo-icon-selected");

      if ($radio.is(":checked")) {
        $label
          .removeClass("border-gray-200")
          .addClass("border-blue-500 opacity-80");
        $iconSpan
          .removeClass("promo-icon-default")
          .addClass("promo-icon-selected");
      } else {
        $label
          .removeClass("border-blue-500 opacity-80")
          .addClass("border-gray-200");
        $iconSpan
          .removeClass("promo-icon-selected")
          .addClass("promo-icon-default");
      }
    });
  }

  // Display promotion type sections
  function displayPromoType() {
    var promoTypeBasicRadio = document.getElementById("promotion-type-basic");
    var promoTypeLastRadio = document.getElementById(
      "promotion-type-last_minute",
    );
    var promoTypeEarlyRadio = document.getElementById(
      "promotion-type-early-booker",
    );

    if (promoTypeBasicRadio && promoTypeBasicRadio.checked) {
      $(".js-promo-advanced-settings").slideDown(400);
      $(".js-early-bird").slideUp(400);
      $(".js-last-minute").slideUp(400);
      $(".js-promotion-title-field").slideDown(400);
    } else if (promoTypeLastRadio && promoTypeLastRadio.checked) {
      $(".js-last-minute").slideDown(400);
      $(".js-early-bird").slideUp(400);
      $(".js-promo-advanced-settings").slideUp(400);
      $(".js-promotion-title-field").slideUp(400);
    } else if (promoTypeEarlyRadio && promoTypeEarlyRadio.checked) {
      $(".js-early-bird").slideDown(400);
      $(".js-promo-advanced-settings").slideUp(400);
      $(".js-last-minute").slideUp(400);
      $(".js-promotion-title-field").slideUp(400);
    }
  }

  // Initialize all checkboxes
  function initializeAllCheckboxes() {
    $(".j-rate-plan-selectable").each(function () {
      if ($(this).prev(".custom-checkbox").length === 0) {
        $(this).before('<span class="custom-checkbox">');
      }
      if (typeof setCheckbox === "function") {
        setCheckbox($(this));
      }
    });
    $(".j-booking-selectable").each(function () {
      if ($(this).prev(".custom-checkbox").length === 0) {
        $(this).before('<span class="custom-checkbox">');
      }
      if (typeof setCheckbox === "function") {
        setCheckbox($(this));
      }
    });
  }

  // Initialize room selection observer
  function initializeRoomSelectionObserver() {
    var roomSelectionObserver = new MutationObserver(function (mutations) {
      setTimeout(function () {
        $(".j-promotion-form-room-selection .j-booking-selectable").each(
          function () {
            if ($(this).prev(".custom-checkbox").length === 0) {
              $(this).before('<span class="custom-checkbox">');
            }
            if (typeof setCheckbox === "function") {
              setCheckbox($(this));
            }
          },
        );
      }, 100);
    });

    var roomSelectionContainer = document.querySelector(
      ".j-promotion-form-room-selection",
    );
    if (roomSelectionContainer) {
      roomSelectionObserver.observe(roomSelectionContainer, {
        childList: true,
        subtree: true,
      });
    }
  }

  // Handle room selection radio
  function initializeRoomSelection() {
    $("#every_room_radio").on("change", function () {
      if ($(this).is(":checked")) {
        $(
          ".j-promotion-form-room-selection .j-booking-selectable:not(:disabled)",
        )
          .prop("checked", true)
          .trigger("change");
        setTimeout(function () {
          $(".j-promotion-form-room-selection .j-booking-selectable").each(
            function () {
              if (typeof setCheckbox === "function") {
                setCheckbox($(this));
              }
            },
          );
        }, 100);
      }
    });

    $("body").on(
      "change",
      ".j-promotion-form-room-selection .j-booking-selectable",
      function () {
        var allChecked = true;
        $(
          ".j-promotion-form-room-selection .j-booking-selectable:not(:disabled)",
        ).each(function () {
          if (!$(this).is(":checked")) {
            allChecked = false;
            return false;
          }
        });
        if (!allChecked) {
          $("#every_room_radio").prop("checked", false);
        } else {
          $("#every_room_radio").prop("checked", true);
        }
      },
    );
  }

  // Handle rate plans selection
  function initializeRatePlansSelection() {
    $("#every_open_rate_radio").on("change", function () {
      if ($(this).is(":checked")) {
        $(
          ".promotion-details-rates:not(#closed-rates-section) .j-associated-rate-plans:not(:disabled)",
        )
          .prop("checked", true)
          .trigger("change");
        setTimeout(function () {
          $(
            ".promotion-details-rates:not(#closed-rates-section) .j-associated-rate-plans",
          ).each(function () {
            if (typeof setCheckbox === "function") {
              setCheckbox($(this));
            }
          });
        }, 100);
      }
    });

    $("body").on("change", ".j-associated-rate-plans", function () {
      var allChecked = true;
      $(
        ".promotion-details-rates:not(#closed-rates-section) .j-associated-rate-plans:not(:disabled)",
      ).each(function () {
        if (!$(this).is(":checked")) {
          allChecked = false;
          return false;
        }
      });
      if (!allChecked) {
        $("#every_open_rate_radio").prop("checked", false);
      } else {
        $("#every_open_rate_radio").prop("checked", true);
      }
    });
  }

  // Initialize checked state for rooms and rates
  function initializeCheckedState() {
    setTimeout(function () {
      var allRoomsChecked = true;
      $(
        ".j-promotion-form-room-selection .j-booking-selectable:not(:disabled)",
      ).each(function () {
        if (!$(this).is(":checked")) {
          allRoomsChecked = false;
          return false;
        }
      });
      if (
        allRoomsChecked &&
        $(
          ".j-promotion-form-room-selection .j-booking-selectable:not(:disabled)",
        ).length > 0
      ) {
        $("#every_room_radio").prop("checked", true);
      }

      var allRatesChecked = true;
      $(
        ".promotion-details-rates:not(#closed-rates-section) .j-associated-rate-plans:not(:disabled)",
      ).each(function () {
        if (!$(this).is(":checked")) {
          allRatesChecked = false;
          return false;
        }
      });
      if (
        allRatesChecked &&
        $(
          ".promotion-details-rates:not(#closed-rates-section) .j-associated-rate-plans:not(:disabled)",
        ).length > 0
      ) {
        $("#every_open_rate_radio").prop("checked", true);
      }
    }, 600);
  }

  // Initialize stay date pickers
  function initializeStayDatePickers() {
    var locale = getLocale();
    $.fn.datepicker.defaults.format = "dd/mm/yyyy";

    if (
      $("#promotion_start_stay_date").length &&
      !$("#promotion_start_stay_date").data("datepicker")
    ) {
      $("#promotion_start_stay_date").datepicker({
        autoclose: true,
        assumeNearbyYear: true,
        startView: "month",
        todayHighlight: true,
        weekStart: 1,
        language: locale,
        startDate: -Infinity,
      });
    }

    if (
      $("#promotion_end_stay_date").length &&
      !$("#promotion_end_stay_date").data("datepicker")
    ) {
      $("#promotion_end_stay_date").datepicker({
        autoclose: true,
        assumeNearbyYear: true,
        startView: "month",
        todayHighlight: true,
        weekStart: 1,
        language: locale,
        startDate: -Infinity,
      });
    }

    // If the arrival date is past the departure date then the departure date is changed
    $("#promotion_start_stay_date")
      .off("change.datepicker")
      .on("change", function () {
        if (
          $("#promotion_start_stay_date").data("datepicker") &&
          $("#promotion_end_stay_date").data("datepicker")
        ) {
          var startDate = $("#promotion_start_stay_date")
            .datepicker("getFormattedDate")
            .split("/")
            .reverse()
            .join("/");
          var endDate = $("#promotion_end_stay_date")
            .datepicker("getFormattedDate")
            .split("/")
            .reverse()
            .join("/");
          if (startDate >= endDate) {
            var startDatePlus1 = new Date(startDate);
            startDatePlus1.setDate(startDatePlus1.getDate() + 1);
            $("#promotion_end_stay_date").datepicker("update", startDatePlus1);
          }
        }
      });

    // If the departure date is before the arrival date then the arrival date is changed
    $("#promotion_end_stay_date")
      .off("change.datepicker")
      .on("change", function () {
        if (
          $("#promotion_start_stay_date").data("datepicker") &&
          $("#promotion_end_stay_date").data("datepicker")
        ) {
          var startDate = $("#promotion_start_stay_date")
            .datepicker("getFormattedDate")
            .split("/")
            .reverse()
            .join("/");
          var endDate = $("#promotion_end_stay_date")
            .datepicker("getFormattedDate")
            .split("/")
            .reverse()
            .join("/");
          if (startDate >= endDate) {
            var endDateMinus1 = new Date(endDate);
            endDateMinus1.setDate(endDateMinus1.getDate() - 1);
            $("#promotion_start_stay_date").datepicker("update", endDateMinus1);
          }
        }
      });
  }

  // Initialize reservation date pickers
  function initializeReservationDatePickers() {
    var locale = getLocale();
    $.fn.datepicker.defaults.format = "dd/mm/yyyy";

    if (
      $("#promotion_start_reservation_date").length &&
      !$("#promotion_start_reservation_date").data("datepicker")
    ) {
      $("#promotion_start_reservation_date").datepicker({
        autoclose: true,
        assumeNearbyYear: true,
        startView: "month",
        todayHighlight: true,
        weekStart: 1,
        language: locale,
        startDate: -Infinity,
      });
    }

    if (
      $("#promotion_end_reservation_date").length &&
      !$("#promotion_end_reservation_date").data("datepicker")
    ) {
      $("#promotion_end_reservation_date").datepicker({
        autoclose: true,
        assumeNearbyYear: true,
        startView: "month",
        todayHighlight: true,
        weekStart: 1,
        language: locale,
        startDate: -Infinity,
      });
    }

    // If the arrival date is past the departure date then the departure date is changed
    $("#promotion_start_reservation_date")
      .off("change.datepicker")
      .on("change", function () {
        if (
          $("#promotion_start_reservation_date").data("datepicker") &&
          $("#promotion_end_reservation_date").data("datepicker")
        ) {
          var startDate = $("#promotion_start_reservation_date")
            .datepicker("getFormattedDate")
            .split("/")
            .reverse()
            .join("/");
          var endDate = $("#promotion_end_reservation_date")
            .datepicker("getFormattedDate")
            .split("/")
            .reverse()
            .join("/");
          if (startDate >= endDate) {
            var startDatePlus1 = new Date(startDate);
            startDatePlus1.setDate(startDatePlus1.getDate() + 1);
            $("#promotion_end_reservation_date").datepicker(
              "update",
              startDatePlus1,
            );
          }
        }
      });

    // If the departure date is before the arrival date then the arrival date is changed
    $("#promotion_end_reservation_date")
      .off("change.datepicker")
      .on("change", function () {
        if (
          $("#promotion_start_reservation_date").data("datepicker") &&
          $("#promotion_end_reservation_date").data("datepicker")
        ) {
          var startDate = $("#promotion_start_reservation_date")
            .datepicker("getFormattedDate")
            .split("/")
            .reverse()
            .join("/");
          var endDate = $("#promotion_end_reservation_date")
            .datepicker("getFormattedDate")
            .split("/")
            .reverse()
            .join("/");
          if (startDate >= endDate) {
            var endDateMinus1 = new Date(endDate);
            endDateMinus1.setDate(endDateMinus1.getDate() - 1);
            $("#promotion_start_reservation_date").datepicker(
              "update",
              endDateMinus1,
            );
          }
        }
      });
  }

  // Initialize advanced settings
  function initializeAdvancedSettings() {
    var promoAdvancedSettings = document.getElementById(
      "j-promo-adv-set-radio",
    );
    if (promoAdvancedSettings) {
      function displayPromoAdvancedSettings() {
        var radioYes = document.getElementById(
          "promotion-advanced-settings-yes",
        );
        if (radioYes && radioYes.checked) {
          $(".j-promo-adv-set-div").slideDown(400);
          setTimeout(function () {
            initializeReservationDatePickers();
          }, 450);
        } else {
          $(".j-promo-adv-set-div").slideUp(400);
        }
      }

      displayPromoAdvancedSettings();
      promoAdvancedSettings.addEventListener(
        "click",
        displayPromoAdvancedSettings,
      );
      $("#promotion-advanced-settings-yes, #promotion-advanced-settings-no").on(
        "change",
        displayPromoAdvancedSettings,
      );
    }

    var limitVisibility = document.getElementById(
      "j-promo-limit-visibility-radio",
    );
    if (limitVisibility) {
      function displaylimitVisibility() {
        var radioYes = document.getElementById(
          "promotion-limit-visibility-yes",
        );
        if (radioYes && radioYes.checked) {
          $(".js-promo-limit-visibility").slideDown(400);
          setTimeout(function () {
            initializeReservationDatePickers();
          }, 450);
        } else {
          $(".js-promo-limit-visibility").slideUp(400);
        }
      }

      displaylimitVisibility();
      limitVisibility.addEventListener("click", displaylimitVisibility);
      $("#promotion-limit-visibility-yes, #promotion-limit-visibility-no").on(
        "change",
        displaylimitVisibility,
      );
    }
  }

  function initializeClosedRatesToggle() {
    var $closedRatesLink = $("#show-closed-rates-link");
    var $closedRatesSection = $("#closed-rates-section");

    if ($closedRatesLink.length === 0 || $closedRatesSection.length === 0) {
      return;
    }

    function updateClosedRatesVisibility() {
      var hasCheckedClosedRates =
        $closedRatesSection.find(".j-associated-rate-plans:checked").length > 0;
      if (hasCheckedClosedRates) {
        $closedRatesSection.removeClass("hidden");
        $closedRatesLink.text(
          $closedRatesLink.data("hide-text") ||
            t("index.promotion.hide_closed_rates"),
        );
      }
    }

    $(document)
      .off("click", "#show-closed-rates-link")
      .on("click", "#show-closed-rates-link", function (e) {
        e.preventDefault();
        e.stopPropagation();

        var $section = $("#closed-rates-section");
        if ($section.hasClass("hidden")) {
          $section.removeClass("hidden");
          $closedRatesLink.text(
            $closedRatesLink.data("hide-text") ||
              t("index.promotion.hide_closed_rates"),
          );
        } else {
          $section.addClass("hidden");
          $closedRatesLink.text(
            $closedRatesLink.data("show-text") ||
              t("index.promotion.show_closed_rates"),
          );
        }
      });

    $("body").on(
      "change",
      "#closed-rates-section .j-associated-rate-plans",
      function () {
        updateClosedRatesVisibility();
      },
    );

    setTimeout(function () {
      updateClosedRatesVisibility();
    }, 100);
  }

  // Main initialization function
  function initializePromotionFormNew() {
    if (!$("#new_promotion, .promotion-form-new").length) {
      return; // Form not present, exit early
    }

    // Initialize language selection
    initializeLanguageSelection();

    // Initialize promotion type handlers
    $('input[name="promotion[promotion_type]"]').on("change", function () {
      updatePromoTypeStyles();
      displayPromoType();
    });
    updatePromoTypeStyles();
    displayPromoType();

    // Initialize checkboxes
    setTimeout(function () {
      initializeAllCheckboxes();
    }, 500);

    // Initialize observers and handlers
    initializeRoomSelectionObserver();
    initializeRoomSelection();
    initializeRatePlansSelection();
    initializeCheckedState();

    // Initialize closed rates toggle
    initializeClosedRatesToggle();

    // Initialize date pickers
    setTimeout(function () {
      initializeStayDatePickers();
    }, 100);

    // Initialize advanced settings
    initializeAdvancedSettings();

    // Initialize closed rates modal handler
    initializeClosedRatesModal();
  }

  function initializeClosedRatesModal() {
    var $form = $("#new_promotion, .promotion-form-new");
    if (!$form.length) {
      return;
    }

    $form
      .off("submit.closedRatesModal")
      .on("submit.closedRatesModal", function (e) {
        if ($form.data("submitting-after-modal")) {
          $form.removeData("submitting-after-modal");
          return true;
        }

        var $closedRatesSection = $("#closed-rates-section");
        if ($closedRatesSection.length === 0) {
          return;
        }

        var $checkedClosedRates = $closedRatesSection.find(
          ".j-associated-rate-plans:checked",
        );
        if ($checkedClosedRates.length === 0) {
          return;
        }

        e.preventDefault();

        var closedRatesNames = [];
        $checkedClosedRates.each(function () {
          var rateName = $('label[for="' + $(this).attr("id") + '"]')
            .text()
            .trim();
          rateName = rateName.replace(/\s*\([^)]*\)\s*$/, "");
          closedRatesNames.push(rateName);
        });

        var $closedRatesList = $("#closed-rates-list");
        $closedRatesList.empty();
        closedRatesNames.forEach(function (name) {
          $closedRatesList.append(
            '<li class="mb-0" style="margin-left: 1.5em;">' +
              '<span class="font-semibold leading-relaxed" style="font-size: 16px; line-height: 1.5; font-weight: 600;">' +
              name +
              "</span></li>",
          );
        });

        $("#promotionClosedRatesModal")
          .one("hidden.bs.modal", function () {
            setTimeout(function () {
              $form.data("submitting-after-modal", true);
              $form.submit();
            }, 100);
          })
          .modal("show");
      });

    $("#promotionClosedRatesModal").on(
      "click",
      ".js-go-to-rate-plans",
      function (e) {
        e.preventDefault();
        $form.data("redirect-to-rate-plans", true);
        $form.find('input[name="redirect_to_rate_plans"]').remove();
        $form.append(
          '<input type="hidden" name="redirect_to_rate_plans" value="true">',
        );
        $("#promotionClosedRatesModal").modal("hide");
      },
    );
  }

  // Initialize when DOM is ready
  $(document).ready(function () {
    initializePromotionFormNew();
  });

  // Also initialize on turbolinks:load if using Turbolinks
  $(document).on("turbolinks:load", function () {
    initializePromotionFormNew();
  });
})();
